/* eslint-disable react/jsx-key */
import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';
import Button from '../../Atoms/Button';
import VideoBox from '../../Molecules/VideoBox';
import Image from '../../Atoms/Image';
import InViewAnimate from '../../Atoms/InViewAnimate';
import LogoList from '../../Molecules/LogoList';
import List from '../../Molecules/List';
import CardContact from '../../Molecules/CardContact';
import { Props as CardVacancyProps } from '../../Molecules/CardVacancy';
import CardReviewSlider from '../../Organisms/CardReviewSlider';
import CardVacancyCarousel from '../../Organisms/CardVacancyCarousel';
import BannerCV from '../../Organisms/BannerCV';

import bgHero from '../../../assets/img/expertise-header-bg.jpg';
import clock from '../../../assets/img/model-1500werkgevers.svg';
import modelMan from '../../../assets/img/expertise-model.webp';

import reviews from '../../../data/cardReviewSliderData';
import vacancyList from '../../../data/vacancyListData';

import InputText from '../../Atoms/InputText';
import InputFileExt from '../../Atoms/InputFileExt';

import { logosExpertise } from '../../../data/logosListAndImageSliderData';
import svg from '../../../constants/svg';

function Expertise() {
  return (
    <>
      <div className="relative rounded-b-2xl bg-sl-blue-dark pt-24 pb-12 text-white md:pt-24 md:pb-20 lg:pb-36 lg:pt-52">
        <div className="relative z-20 mx-auto w-full max-w-7xl px-7">
          <div className="mx-auto flex max-w-lg flex-col lg:max-w-full lg:flex-row">
            <div className="flex w-full max-w-sm flex-col gap-5 md:max-w-xl lg:max-w-3xl">
              <Title as="h1" color="inherit" weight={900}>
                <span>
                  Dé specialist voor Monteurs in de
                  Technische Dienst
                </span>
              </Title>
              <Text font="circular" color="inherit">
                <span className="text-lg md:text-xl lg:text-2xl">
                  Kies uit de beste banen in de industrie
                </span>
              </Text>
              <div className="mt-5">
                <Button
                  text="Bekijk alle 799 vacatures"
                  iconName="arrow-right"
                  color="accent"
                  shadow
                />
              </div>
            </div>
            <VideoBox
              url="https://youtu.be/_EEvzgEbJiM"
              className="absolute top-full left-7 right-7 z-10 mx-auto mt-20 max-w-lg md:mt-7 lg:left-auto lg:w-full lg:-translate-y-1/3"
            >
              <div className="h-full w-full p-7 text-white">
                <div className="flex h-full w-full items-center justify-center overflow-y-auto sm:justify-start">
                  <div className="grid gap-y-3 sm:max-w-[250px]">
                    <Title
                      as="h4"
                      size={5}
                      color="white"
                      weight={900}
                      className="hidden sm:block"
                    >
                      <span>
                        De beste banen
                        <br /> voor <b>Monteurs</b>
                      </span>
                    </Title>
                    <Text
                      color="inherit"
                      weight={500}
                      className="hidden sm:block"
                    >
                      <span className="text-sm lg:text-base">
                        Jij weet wat je wil en wij weten
                        waar je dat kan doen. Check de video
                        om te zien hoe wij dat doen!
                      </span>
                    </Text>
                    <span className="my-auto flex flex-row items-center gap-3 sm:mt-auto">
                      <Button
                        iconName="play"
                        fullRounded
                        color="white"
                        size="lg"
                      />
                      <Text
                        color="inherit"
                        className="hidden sm:inline-flex"
                        weight={600}
                      >
                        Speel af
                      </Text>
                    </span>
                  </div>
                </div>
              </div>
            </VideoBox>
          </div>
        </div>
        <div className="pointer-events-none absolute inset-0 z-10 after:absolute after:inset-0 after:bg-sl-blue-dark after:opacity-70 md:after:block md:after:opacity-40 lg:after:hidden">
          <Image
            src={bgHero}
            alt="bg image"
            className="h-full w-full object-cover object-right-bottom"
          />
        </div>
      </div>
      <div className="relative mt-[55vw] bg-white pt-12 pb-0 sm:mt-80 md:mt-60 md:pb-16 lg:mt-20 lg:pb-24">
        <div className="relative z-20 mx-auto w-full max-w-7xl px-7 md:px-3.5">
          <div className="flex flex-col items-stretch gap-7 md:flex-row md:gap-0">
            <div className="w-full text-sl-blue md:max-w-[52%] md:px-3.5">
              <Title
                as="h2"
                color="inherit"
                weight={900}
                className="mb-8"
              >
                Jij weet wat je wil en wij weten waar je dat
                kan doen.
              </Title>
              <Text>
                Op basis van jouw wensen en ambities vinden
                wij voor jou de best passende baan. Dit
                kunnen wij doen door ons grote netwerk van
                1800 innovatieve werkgevers binnen de
                Industrie specifiek voor Mechanisch
                Monteurs, Elektromonteurs, Allround Monteurs
                en Besturingstechnici. Denk hierbij aan
                bedrijven binnen de food-, chemie-, farma-,
                automotive-, papier-, rubber & kunststof-,
                verpakkings- en metaalindustrie.
              </Text>
              <LogoList
                images={logosExpertise}
                className="mt-10 mb-5 justify-center md:justify-start"
              />
            </div>
            <div className="relative w-full md:max-w-[48%] md:px-3.5">
              <Image
                src={clock}
                alt="sand clock"
                className="pointer-events-none top-0 left-3.5 right-3.5 mx-auto -mb-20 md:absolute md:mb-0 md:mr-0"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="relative bg-sl-blue pt-24 pb-0 text-white md:pt-32">
        <div className="relative z-20 mx-auto w-full max-w-7xl px-7">
          <div className="relative flex flex-col justify-between gap-16 pb-16 sm:flex-row md:gap-32 lg:gap-60 lg:pb-32">
            <div className="relative z-10 flex flex-col sm:w-1/2">
              <Title
                as="h2"
                size={5}
                color="inherit"
                className="mb-5"
              >
                Specialist in de Technische Dienst
              </Title>
              <Text
                color="inherit"
                className="mb-16 last:mb-0 md:mb-24"
              >
                We zijn een technisch detacheringsbureau
                specifiek voor Monteurs in de Technische
                Dienst. We doen al 10 jaar niets anders dan
                de beste baan vinden voor monteurs in de
                industrie.
              </Text>
              <Title
                as="h2"
                size={5}
                color="inherit"
                className="mb-5"
              >
                Wij kennen de markt, weten precies wat er
                speelt en wat jouw opties zijn
              </Title>
              <Text
                color="inherit"
                className="mb-16 last:mb-0 md:mb-24"
              >
                Zelf kan je niet alle bedrijven en vacatures
                kennen en weten of het bij jouw wensen en
                ambities past. Omdat wij in contact staan
                met alle technische diensten weten wij wat
                er mogelijk is voor jou binnen de
                verschillende industrieën, machineparken,
                technieken en ploegendiensten.
              </Text>
              <Title
                as="h2"
                size={5}
                color="inherit"
                className="mb-5"
              >
                Wij weten deuren te openen die voor jou
                gesloten blijven
              </Title>
              <Text
                color="inherit"
                className="mb-16 last:mb-0 md:mb-24"
              >
                Wij gaan met een Hoofd Technische Dienst in
                gesprek over jouw wensen en kwaliteiten om
                ervoor te zorgen dat er specifiek voor jou
                mogelijkheden worden gecreëerd.
              </Text>
            </div>

            <div className="relative z-10 flex flex-col sm:w-1/2 md:mt-40 lg:mt-64">
              <Title
                as="h2"
                size={5}
                color="inherit"
                className="mb-5"
              >
                Je hoeft alleen maar te kiezen
              </Title>
              <Text
                color="inherit"
                className="mb-16 last:mb-0 md:mb-24"
              >
                Onze dienstverlening voor jou is enorm
                simpel. Aan de hand van jouw wensen gaan wij
                op zoek naar de beste baan. Wij zorgen voor
                de beste opties, jij hoeft alleen maar te
                kiezen.
              </Text>
              <Title
                as="h2"
                size={5}
                color="inherit"
                className="mb-5"
              >
                Jij staat centraal
              </Title>
              <Text
                color="inherit"
                className="mb-16 last:mb-0 md:mb-24"
              >
                Wij vinden de beste baan waarin jij wordt
                gewaardeerd vanwege jouw expertise, waar je
                blijvend technisch wordt uitgedaagd en
                passend voor wordt beloond. Alleen vaste
                banen voor de beste toekomst.
              </Text>
            </div>

            <div className="pointer-events-none absolute inset-0 z-0 hidden w-full lg:block">
              <span className="absolute left-1/4 top-full h-40 w-40 -translate-x-full -translate-y-full">
                {svg.qrbCircle}
              </span>
              <span className="absolute left-full top-1/2 h-40 w-40 translate-x-1/4 -translate-y-1/3">
                {svg.qrbCircle}
              </span>
              <span className="absolute left-full top-full h-80 w-80 -translate-x-1/3 -translate-y-1/3">
                {svg.lqlbCircleOpen}
              </span>
            </div>
          </div>

          <div className="relative flex flex-col items-center gap-14 pt-0 pb-10 sm:pt-10 md:flex-row md:pb-28 lg:pt-32">
            <div className="w-full text-white md:w-1/2">
              <Text
                font="circular"
                weight={900}
                color="inherit"
                className="mb-3"
              >
                <span className="text-lg md:text-xl lg:text-2xl">
                  Level up your job
                </span>
              </Text>
              <Title
                as="h2"
                size={3}
                weight={900}
                color="inherit"
                className="mb-7 max-w-lg"
              >
                Laat je vertegenwoordigen door Synsel
                Techniek
              </Title>
              <Text
                color="inherit"
                className="mb-10 max-w-sm"
              >
                Jij weet wat je wilt en wij weten waar je
                dat kan doen. Met een vertegenwoordiger van
                Synsel Techniek ben je ervan verzekerd dat
                jouw belangen worden behartigd. Upload nu je
                CV laat ons de beste baan voor je vinden.
              </Text>
              <List
                icon="checkmark"
                listItems={[
                  <Title
                    size={6}
                    color="white"
                    weight={400}
                  >
                    <span className="text-base">
                      Binnen <b>1 uur</b> reactie
                    </span>
                  </Title>,
                  <Title
                    size={6}
                    color="white"
                    weight={400}
                  >
                    <span className="text-base">
                      Geen klik? Wij vinden de{' '}
                      <b>passende baan</b>
                    </span>
                  </Title>,
                  <Title
                    size={6}
                    color="white"
                    weight={400}
                  >
                    <span className="text-base">
                      Monteurs beoordelen ons met een{' '}
                      <b>8.9</b>
                    </span>
                  </Title>
                ]}
              />
            </div>
            <div className="w-full md:w-1/2">
              <div className="flex h-auto max-w-full flex-col rounded-xl bg-white p-7 md:ml-auto md:w-96">
                <Title
                  as="h2"
                  size={5}
                  weight={900}
                  className="mb-8"
                >
                  Deel jouw CV
                </Title>
                <form action="#!" className="grid gap-y-4">
                  <InputText
                    label="Voornaam"
                    autoComplete="first-name"
                  />
                  <InputText
                    label="Achternaam"
                    autoComplete="family-name"
                  />
                  <InputText
                    label="Jouw e-mailadres"
                    autoComplete="email"
                  />
                  <InputFileExt />
                  <Button
                    text="Versturen"
                    iconName="arrow-right"
                    color="accent"
                    shadow
                    fluid
                  />
                </form>
              </div>
            </div>
            <div className="pointer-events-none absolute inset-0 -z-10 hidden md:block">
              <Image
                src={modelMan}
                alt="description"
                className="absolute bottom-0 left-1/2 h-96 -translate-x-3/4 lg:h-auto lg:-translate-x-1/2"
              />
            </div>
          </div>
        </div>
        <div className="pointer-events-none absolute inset-0 z-0 hidden w-full lg:block">
          <span className="absolute left-0 bottom-0 h-80 w-80">
            {svg.lqrbCircleOpen}
          </span>
        </div>
      </div>

      <div className="relative flex flex-col  bg-sl-indigo pt-16 pb-10 lg:py-24">
        <div className="relative z-20 mx-auto w-full max-w-7xl px-7">
          <Title
            as="h2"
            className="text-center"
            color="white"
          >
            <span>
              1.533 tevreden kandidaten <br /> gingen je
              voor!
            </span>
          </Title>
        </div>
        <div className="overflow-hidden lg:mt-12">
          <CardReviewSlider reviewList={reviews} />
        </div>

        <InViewAnimate
          once
          hiddenClass="opacity-0 translate-x-14"
          visibleClass="opacity-100 translate-x-0"
          className="-bottom-48 left-1/2 z-20 w-full px-7 duration-1000 ease-[cubic-bezier(0.17,0.55,0.55,1)] xl:absolute xl:w-[730px] xl:px-0 2xl:ml-16 2xl:w-[780px]"
        >
          <BannerCV />
        </InViewAnimate>
      </div>
      <div
        className="bg-sl-gray-light pt-16 pb-10 lg:py-28"
        style={{ backgroundColor: '#f7f8ff' }}
      >
        <div className="mx-auto flex max-w-7xl flex-col px-7">
          <Title as="h2" size={2} className="text-left">
            Gerelateerde vacatures
          </Title>
          <CardVacancyCarousel
            navigationPosY="bottom"
            utilityButton={{
              text: 'Bekijk alles',
              color: 'secondary-outline',
              iconName: 'grid'
            }}
            vacancyList={vacancyList as CardVacancyProps[]}
          />
        </div>
      </div>
      <section className="relative bg-white py-10 lg:py-10">
        <div className="mx-auto w-full max-w-7xl px-7">
          <Title as="h2" className="text-center">
            Wij staan voor je klaar
          </Title>

          <div className="grid gap-3 py-5 sm:grid-cols-2 sm:gap-5 md:grid-cols-4 lg:gap-7">
            <CardContact
              title="Bel"
              description="Direct contact"
              text="088 - 3231300"
              icon="phone"
              urlType="tel"
              url="#!"
            />
            <CardContact
              title="Chat"
              description="Direct antwoord"
              text="Chat met ons"
              icon="comments"
              url="#!"
            />
            <CardContact
              title="App"
              description="Binnen 2 uur reactie"
              text="0619734306"
              icon="whatsapp"
              url="#!"
            />
            <CardContact
              title="Mail"
              description="Binnen 1 dag reactie"
              text="talent@synsel.nl"
              icon="mail"
              url="#!"
              urlType="mail"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Expertise;
